import { Outlet, useLocation, useNavigate } from "react-router-dom";

// Campaign years follow their names and launch history; general forms stay separate.
const campaignGroups = [
  {
    "year": "2026",
    "campaigns": [
      ["ford-event-game-merch-new-requests", "Участници в новата игра Ford"],
      [
        "ford-event-game-september-2026-requests",
        "Участници в играта Ford — септември 2026"
      ],
      [
        "ford-event-game-requests",
        "Участници в играта Ford July 2026"
      ],
      [
        "pleven-open-requests",
        "Запитвания за Дни на отворени врати Плевен"
      ],
      [
        "puma-family-2026-requests",
        "Запитвания за Puma Family 2026"
      ],
      [
        "puma-2026-april-campaign-requests",
        "Запитвания за Puma април 2026"
      ],
      [
        "ranger-q3-2026-requests",
        "Запитвания за Ranger Q3 2026"
      ],
      [
        "kuga-full-hybrid-requests",
        "Запитвания за Kuga Full Hybrid март 2026"
      ],
      [
        "kuga-june-2026-requests",
        "Запитвания за Kuga юни 2026"
      ],
      [
        "kuga-august-2026-requests",
        "Запитвания за Kuga август 2026"
      ],
      [
        "transit-courier-april-2026-getintouch-requests",
        "Свържи се с търговец за Transit Courier април 2026"
      ],
      [
        "transit-courier-double-cab-in-van-getintouch-requests",
        "Свържи се с търговец за Transit Courier Double Cab-in-Van"
      ],
      [
        "focus-promo-requests",
        "Запитвания за Focus Promo"
      ],
      [
        "fordpro-requests",
        "Запитвания за Ford Pro Range"
      ]
    ]
  },
  {
    "year": "2025",
    "campaigns": [
      [
        "puma2025-requests",
        "Запитвания за Puma 2025"
      ],
      [
        "kuga-full-hybrid",
        "Запитвания за Kuga Full Hybrid"
      ],
      [
        "sixty-years-transit",
        "Запитвания за 60 години Transit"
      ],
      [
        "transit-e-courier-requests",
        "Запитвания за Transit-E-Courier"
      ],
      [
        "go-electric-requests",
        "Запитвания по кампанията Go Electric"
      ],
      [
        "roadshow-ev-requests",
        "Запитвания за Go Electric Roadshow EV"
      ],
      [
        "capri-2025-requests",
        "Запитвания за Capri 2025"
      ],
      [
        "puma-gen-e-requests",
        "Запитвания за Puma Gen E"
      ],
      [
        "kuga52990-requests",
        "Запитвания за Kuga 52 990 лв."
      ]
    ]
  },
  {
    "year": "2024",
    "campaigns": [
      [
        "transit-connect-requests",
        "Запитвания за оферта за промоция на Transit Connect"
      ],
      [
        "puma-kuga-requests",
        "Запитвания за оферта за промоция за Puma и Kuga"
      ],
      [
        "transit-custom-requests",
        "Свържи се с търговец за Transit Custom"
      ],
      [
        "bronco-testdrive-requests",
        "Запитвания за тестдрайв за Bronco"
      ],
      [
        "summer2024-requests",
        "Запитвания за оферта - лято'24"
      ],
      [
        "mustang-testdrive-requests",
        "Запитвания за тестдрайв на Mustang"
      ],
      [
        "puma2024-requests",
        "Запитвания за Puma 2024"
      ],
      [
        "electric-explorer-2024-requests",
        "Запитвания за Electric Explorer 2024"
      ]
    ]
  },
  {
    "year": "2023",
    "campaigns": [
      [
        "puma-offer-requests",
        "Запитвания за оферта за Puma с 3 900 лв. първоначални разходи"
      ],
      [
        "puma-getintouch-requests",
        "Свържи се с търговец за Puma"
      ],
      [
        "ranger-requests",
        "Запитвания за Ranger Raptor"
      ],
      [
        "mach-e-offer-requests",
        "Запитвания за оферта за Mach-E"
      ],
      [
        "mach-e-getintouch-requests",
        "Свържи се с търговец за Mach-E"
      ],
      [
        "transit-courier-getintouch-requests",
        "Свържи се с търговец за Transit Courier"
      ],
      [
        "kuga-proposal-requests",
        "Запитвания за оферта за Kuga"
      ],
      [
        "kuga-getintouch-requests",
        "Свържи се с търговец за Kuga"
      ]
    ]
  },
  {
    "year": "Общи запитвания",
    "campaigns": [
      [
        "offer-requests",
        "Запитвания за специална оферта за конкретен автомобил"
      ],
      [
        "testdrive-requests",
        "Запитвания за тестдрайв на конкретен автомобил"
      ],
      [
        "testdrive-page-requests",
        "Общи запитвания за тестдрайв"
      ]
    ]
  }
];

export const Stats = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const selectedPath = campaignGroups
    .flatMap(({ campaigns }) => campaigns)
    .some(([path]) => pathname === `/admin/stats/${path}`)
    ? pathname
    : "";

  return (
    <div>
      <select
        aria-label="Изберете статистика по кампания"
        className="max-w-full"
        value={selectedPath}
        onChange={(event) => navigate(event.target.value)}
      >
        <option value="" disabled>
          Изберете списък със запитвания
        </option>
        {campaignGroups.map(({ year, campaigns }) => (
          <optgroup key={year} label={year}>
            {campaigns.map(([path, label]) => (
              <option key={path} value={`/admin/stats/${path}`}>
                {label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
      <Outlet />
    </div>
  );
};
